// System
import React from "react";
import ReactDOM from "react-dom";

// Styles
import "./index.css";
import Home from "features/landing/home.page";

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById("root")
);
